import { render } from "./SectionTitleDescription.vue?vue&type=template&id=7529f307&scoped=true"
import script from "./SectionTitleDescription.vue?vue&type=script&lang=js"
export * from "./SectionTitleDescription.vue?vue&type=script&lang=js"

import "./SectionTitleDescription.vue?vue&type=style&index=0&id=7529f307&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7529f307"]])

export default __exports__